module.exports = __webpack_public_path__ + "static/media/textediter_bold_active.58be3da7.svg";